import SEOHead from "@/components/base/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "@/pages/home/components/HeroSection";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import FeaturedArticles from "@/pages/home/components/FeaturedArticles";
import CommunityStats from "@/pages/home/components/CommunityStats";
import FAQSection from "@/pages/home/components/FAQSection";
import CTASection from "@/pages/home/components/CTASection";
import SchemaOrg from "@/components/base/SchemaOrg";

export default function Home() {
  return (
    <>
      <SEOHead
        title="猫咪社区——爱猫人的温暖聚集地"
        description="猫咪社区是专为爱猫人士打造的互动平台，汇聚海量猫咪养护经验、萌猫图片分享、健康问答与领养信息。加入猫咪社区，与数十万铲屎官一起交流猫咪饮食、行为、疾病预防等实用知识，让每一只猫咪都被温柔对待。"
        keywords="猫咪社区,猫咪养护交流社区,爱猫人士论坛,铲屎官聚集地,猫咪健康问答,萌猫图片分享社区,猫咪领养信息平台"
        canonicalUrl="https://catcommunity.cn/"
      />
      <SchemaOrg
        type="WebSite"
        data={{
          name: "猫咪社区",
          url: "https://catcommunity.cn/",
          description: "猫咪社区是专为爱猫人士打造的互动平台，汇聚海量猫咪养护经验、萌猫图片分享、健康问答与领养信息。",
          potentialAction: {
            "@type": "SearchAction",
            target: "https://catcommunity.cn/search?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        }}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: "猫咪社区",
          url: "https://catcommunity.cn/",
          description: "爱猫人的温暖聚集地",
          contactPoint: {
            "@type": "ContactPoint",
            email: "hello@catcommunity.cn",
            contactType: "customer service",
          },
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <CommunityStats />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}